module.exports = __webpack_public_path__ + "assets/img/report-act-bg-2.f6a8c1e5.png";